import { render, staticRenderFns } from "./LegoControlCardAuditoria.vue?vue&type=template&id=718be3ed&scoped=true"
import script from "./LegoControlCardAuditoria.vue?vue&type=script&lang=js"
export * from "./LegoControlCardAuditoria.vue?vue&type=script&lang=js"
import style0 from "./LegoControlCardAuditoria.vue?vue&type=style&index=0&id=718be3ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718be3ed",
  null
  
)

export default component.exports